"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectiveType = void 0;
var ObjectiveType;
(function (ObjectiveType) {
    ObjectiveType["building"] = "building";
    ObjectiveType["amount"] = "amount";
})(ObjectiveType = exports.ObjectiveType || (exports.ObjectiveType = {}));
